import React, { useState, useEffect } from 'react';

const CompressedSize = props => {
	const { file, classname } = props;
	const [compressedSize, setCompressedSize] = useState(file.compressedSizeFormatted);
	const [percentageCompression, setPercentageCompression] = useState(file.percentageCompression);
	const formatted = percentageCompression <= 0 ? 'Already optimized' : `${compressedSize}
				(${percentageCompression * -1}%)`;
	const display = percentageCompression === undefined ? '' : formatted;

	function onUpdate(uFile) {
		setCompressedSize(uFile.compressedSizeFormatted);
		setPercentageCompression(uFile.percentageCompression);
	}
	useEffect(() => {
		file.subscribe(onUpdate);
		return () => {
			file.unsubscribe(onUpdate);
		};
	}, []);
	return (
		<span className={classname}>{display}</span>
	);
};

export default CompressedSize;



// WEBPACK FOOTER //
// ./src/components/file-table/CompressedSize.js